import { useContext } from 'react';
import TreeContext from './TreeContext';

export default function useTreeContext() {
  const context = useContext(TreeContext);
  if (context === undefined) {
    throw new Error(
      'useTreeContext must be used within a ReaderContextProvider',
    );
  }
  return context;
}
